<template>
  <tr>
    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ thirdPartyService.service }}
      <div class="text-teal-600 mt-1 italic">last synced: {{ lastSyncedAt }}</div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ thirdPartyService.channel }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <ThirdPartyServiceActiveToggleButton
        :value="thirdPartyService.active"
        :third-party-service-id="thirdPartyService.id"
      />
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
      <Dropdown ref="dropdown">
        <template #button="{ open }">
          <button
            type="button"
            class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
            @click="open"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <circle cx="12" cy="12" r="1" />
              <circle cx="12" cy="19" r="1" />
              <circle cx="12" cy="5" r="1" />
            </svg>
          </button>
        </template>

        <div
          class="origin-top-right absolute right-0 mt-2 max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="py-1">
            <button
              type="button"
              class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              role="menuitem"
              @click="edit"
            >
              Edit
            </button>
            <button
              type="button"
              class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 disabled:text-gray-400"
              role="menuitem"
              :disabled="isInSync"
              @click="sync"
            >
              {{ isInSync ? 'Syncing...' : 'Sync' }}
            </button>
          </div>
          <div class="py-1">
            <button
              type="button"
              class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
              role="menuitem"
              @click="confirmDestroy"
            >
              Delete
            </button>
          </div>
        </div>
      </Dropdown>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import { woocommerceApiServicesClient } from '@/api/clients';
import ThirdPartyServiceActiveToggleButton from './ThirdPartyServiceActiveToggleButton.vue';

export default {
  components: {
    ThirdPartyServiceActiveToggleButton,
  },
  props: {
    thirdPartyService: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isInSync() {
      return typeof this.thirdPartyService.config.syncStartedAt === 'string';
    },
    lastSyncedAt() {
      if (typeof this.thirdPartyService.config.syncLastCompletedAt === 'string') {
        return moment(this.thirdPartyService.config.syncLastCompletedAt).fromNow();
      }

      return 'never';
    },
  },
  methods: {
    edit() {
      this.$modal.show({
        component: 'WoocommerceApiServiceEditModal',
        props: {
          thirdPartyServiceId: this.thirdPartyService.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async sync() {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.thirdPartyService.id,
          formData: {},
          service: woocommerceApiServicesClient.sync,
        });
      } catch (error) {
        //
      }
    },
    confirmDestroy() {
      const vm = this;

      this.$modal.show({
        component: 'ThirdPartyServiceDestroyModal',
        props: {
          thirdPartyServiceId: this.thirdPartyService.id,
        },
        on: {
          destroyed: () => {
            vm.afterDestroy();
          },
        },
        hideEvent: 'hide',
      });
    },
    afterDestroy() {
      this.$store.commit('ui/accountThirdPartyServices/removeIdFromParent', {
        parentId: this.thirdPartyService.accountId,
        id: this.thirdPartyService.id,
      });
    },
  },
};
</script>
